"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_ui_1 = require("material-ui");
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var utils_1 = require("../../utils");
var reduxFormWrappers_1 = require("./reduxFormWrappers");
var UasAutoComplete = function (_a) {
    var inputRef = _a.inputRef, dispatch = _a.dispatch, props = __rest(_a, ["inputRef", "dispatch"]);
    return (react_1.default.createElement(material_ui_1.AutoComplete, __assign({}, props, { ref: inputRef, textFieldStyle: __assign({ width: '100%' }, lodash_1.get(props, 'textFieldStyle', [])) })));
};
var compareFn = function (val1, val2) {
    if (lodash_1.isString(val1) && lodash_1.isString(val2)) {
        return val1 === val2;
    }
    else {
        if (lodash_1.isObject(val1) && lodash_1.isObject(val2)) {
            if (lodash_1.get(val1, 'id') || lodash_1.get(val2, 'id')) {
                return lodash_1.get(val1, 'id', -1) === lodash_1.get(val2, 'id', -2);
            }
            else {
                return lodash_1.isEqual(val1, val2);
            }
        }
    }
    return false;
};
var ComposedAutoComplete = recompose_1.compose(recompose_1.pure, recompose_1.renameProp('label', 'hintText'), recompose_1.defaultProps({
    filter: material_ui_1.AutoComplete.noFilter,
    callback: lodash_1.noop,
    labelFunction: lodash_1.identity,
    valueFunction: lodash_1.identity,
    items: [],
    onChange: lodash_1.noop,
    onNewItem: lodash_1.noop,
    onUpdateInputChange: lodash_1.noop,
    openOnFocus: true,
    sorting: true,
    clearOnBlur: true,
    compareFn: compareFn,
    popoverProps: {
        canAutoPosition: true,
    },
    menuProps: {
        maxHeight: 250,
        menuItemStyle: {
            padding: '5px',
            borderBottomStyle: 'solid',
            borderColor: '#889ac5',
            borderWidth: '1px',
            whiteSpace: 'normal',
            textIndent: '-10px',
            lineHeight: '25px',
        },
    },
}), recompose_1.mapProps(function (_a) {
    var labelFunction = _a.labelFunction, valueFunction = _a.valueFunction, items = _a.items, sorting = _a.sorting, rest = __rest(_a, ["labelFunction", "valueFunction", "items", "sorting"]);
    var dataSource = items.map(function (item) { return ({
        text: labelFunction(item),
        value: valueFunction(item),
    }); });
    return __assign({ labelFunction: utils_1.safe(labelFunction), valueFunction: utils_1.safe(valueFunction, ''), dataSource: sorting
            ? dataSource.sort(function (_a, _b) {
                var _c = _a.text, text1 = _c === void 0 ? '' : _c;
                var _d = _b.text, text2 = _d === void 0 ? '' : _d;
                return text1.localeCompare(text2);
            })
            : dataSource }, rest);
}), recompose_1.withState('searchText', 'setSearchText', null), recompose_1.withHandlers({
    onUpdateInput: function (_a) {
        var setSearchText = _a.setSearchText, onChange = _a.onChange, onUpdateInputChange = _a.onUpdateInputChange;
        return function (value) {
            setSearchText(value);
            onUpdateInputChange(value);
            // reset selected value to null if the text is deleted
            if (value === '') {
                onChange(null);
            }
        };
    },
    onNewRequest: function (props) { return function (request) {
        var onChange = props.onChange, onNewItem = props.onNewItem, dataSource = props.dataSource, setSearchText = props.setSearchText, compareFn = props.compareFn;
        var value = request.value;
        if (value === undefined) {
            // try to coerce the string with loaded item
            var found = dataSource.find(function (item) { return compareFn(item.text, request); });
            if (found != null) {
                return onChange(found.value);
            }
            else {
                // try to create the new item
                var newItem = onNewItem(request, props);
                if (newItem != null) {
                    return onChange(newItem);
                }
                else {
                    setSearchText('');
                    return onChange(null);
                }
            }
        }
        else {
            return onChange(value);
        }
    }; },
    onBlur: function (_a) {
        var value = _a.value, clearOnBlur = _a.clearOnBlur, setSearchText = _a.setSearchText, onBlur = _a.onBlur;
        return function () {
            if (clearOnBlur && !value) {
                setSearchText('');
            }
            if (typeof onBlur === 'function') {
                onBlur();
            }
        };
    },
}), recompose_1.lifecycle({
    componentDidMount: function () {
        var _a = this.props, value = _a.value, setSearchText = _a.setSearchText, dataSource = _a.dataSource, compareFn = _a.compareFn;
        if (value) {
            var found = dataSource.find(function (item) { return compareFn(item.value, value); });
            if (found != null) {
                setSearchText(found.text || '');
            }
        }
    },
    componentWillReceiveProps: function (nextProps) {
        var value = nextProps.value, setSearchText = nextProps.setSearchText, dataSource = nextProps.dataSource, compareFn = nextProps.compareFn, callback = nextProps.callback, searchText = nextProps.searchText;
        var _a = this.props, oldValue = _a.value, oldDataSource = _a.dataSource;
        // skip if previous value means loading (oldValue == []) and we have already written something into it
        // in case we haven't written anything => iniciatization and the searchText needs to be extracted from
        // value
        if (Array.isArray(oldValue) && oldValue.length === 0 && !!searchText) {
            return;
        }
        if (oldValue !== value) {
            var found = dataSource.find(function (item) { return compareFn(item.value, value); });
            if (found != null) {
                setSearchText(found.text || '');
            }
            if (value == null || value === '') {
                setSearchText('');
            }
        }
        else if (dataSource !== oldDataSource) {
            var found = dataSource.find(function (item) { return compareFn(item.value, value); });
            if (found != null) {
                setSearchText(found.text || '');
            }
        }
        callback(this.props, nextProps);
    },
}), recompose_1.mapProps(function (_a) {
    var callback = _a.callback, compareFn = _a.compareFn, labelFunction = _a.labelFunction, valueFunction = _a.valueFunction, value = _a.value, setSearchText = _a.setSearchText, onChange = _a.onChange, onNewItem = _a.onNewItem, onUpdateInputChange = _a.onUpdateInputChange, rest = __rest(_a, ["callback", "compareFn", "labelFunction", "valueFunction", "value", "setSearchText", "onChange", "onNewItem", "onUpdateInputChange"]);
    return rest;
}))(UasAutoComplete);
exports.default = ComposedAutoComplete;
exports.FormAutoComplete = reduxFormWrappers_1.formWrapper(ComposedAutoComplete);
//# sourceMappingURL=AutoComplete.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/AutoComplete.js
// module id = 972
// module chunks = 0